export const PAYMENT_TRANSACTION_TYPE = {
  expense: 'expense',
  tax: 'tax',
} as const

export const ALL_PAYMENT_TRANSACTION_TYPES = {
  ...PAYMENT_TRANSACTION_TYPE,
  income: 'income',
} as const

export const PAYMENT_FLOW = {
  express: 'express',
  manual: 'manual',
} as const

export enum PaymentDialogState {
  FORM = 'form',
  RESPONSE = 'response',
}

export const EXPRESS_PAID_THROUGH_NAME = 'Expressz' // keep synced with backend
